/* Rising Sun FPV: Hermes Shipping Cover (replaces the Navidium app).
   - Adds/removes the cover line when the customer ticks the box in the cart or cart drawer.
   - Keeps the cover at the right price tier when the cart changes (4% of merchandise by default,
     rounded up to the next $0.75 step; tiers are the cover product's variants).
   - Removes the cover if nothing else is left in the cart.
   Works with the Warehouse theme's own cart events: 'cart:refresh' re-renders, 'cart:rerendered' fires after. */
(function () {
  'use strict';

  var busy = false;
  var syncTimer = null;
  var loopGuard = { count: 0, since: 0 };

  function cfg() {
    var el = document.querySelector('script[data-rs-cover-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartJson() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function update(updates) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { if (!r.ok) throw new Error('cart update failed'); return r.json(); });
  }

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  // Tier for a merchandise amount (cents): ceil(amount * rate% / 75c), clamped to the available tiers.
  function tierFor(c, cents) {
    var n = Math.ceil((cents * c.rate) / 7500);
    n = Math.max(c.min, Math.min(c.max, n));
    for (var k = n; k >= c.min; k--) { if (c.tiers[k]) return { n: k, id: c.tiers[k][0], price: c.tiers[k][1] }; }
    for (var j = n + 1; j <= c.max; j++) { if (c.tiers[j]) return { n: j, id: c.tiers[j][0], price: c.tiers[j][1] }; }
    return null;
  }

  function split(c, cart) {
    var lines = [], merch = 0;
    (cart.items || []).forEach(function (it) {
      if (it.product_id === c.pid) lines.push(it); else merch += it.final_line_price;
    });
    return { lines: lines, merch: merch };
  }

  function status(msg) {
    document.querySelectorAll('[data-rs-cover] .rs-cover__status').forEach(function (s) { s.textContent = msg; });
  }

  function setBusy(on) {
    document.querySelectorAll('[data-rs-cover]').forEach(function (el) {
      el.classList.toggle('is-busy', on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
      var input = el.querySelector('[data-rs-cover-toggle]');
      if (input) input.disabled = on;
    });
  }

  function setCover(on) {
    var c = cfg();
    if (!c || busy) return;
    busy = true; setBusy(true);
    cartJson().then(function (cart) {
      var s = split(c, cart), updates = {};
      s.lines.forEach(function (l) { updates[l.variant_id] = 0; });
      if (on && s.merch > 0) {
        var t = tierFor(c, s.merch);
        if (t) updates[t.id] = 1;
      }
      if (!Object.keys(updates).length) return null;
      return update(updates);
    }).then(function () {
      status(on ? 'Shipping cover added.' : 'Shipping cover removed.');
      refresh();
    }).catch(function () {
      status('Sorry, that did not work. Please try again.');
      document.querySelectorAll('[data-rs-cover-toggle]').forEach(function (i) { i.checked = !on; });
    }).then(function () { busy = false; setBusy(false); });
  }

  // Make sure an existing cover line matches the cart (right tier, quantity 1, removed if the cart is otherwise empty).
  function sync() {
    var c = cfg();
    if (!c || busy) return;
    var now = Date.now();
    if (now - loopGuard.since > 8000) { loopGuard.since = now; loopGuard.count = 0; }
    if (loopGuard.count >= 3) return; // never ping-pong with the theme
    cartJson().then(function (cart) {
      var s = split(c, cart);
      if (!s.lines.length) return;
      var updates = {};
      if (s.merch <= 0) {
        s.lines.forEach(function (l) { updates[l.variant_id] = 0; });
      } else {
        var t = tierFor(c, s.merch);
        if (!t) return;
        var ok = s.lines.length === 1 && s.lines[0].variant_id === t.id && s.lines[0].quantity === 1;
        if (ok) return;
        s.lines.forEach(function (l) { updates[l.variant_id] = 0; });
        updates[t.id] = 1;
      }
      loopGuard.count++;
      busy = true;
      return update(updates).then(function () { busy = false; refresh(); });
    }).catch(function () { busy = false; });
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay || 60);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-rs-cover-toggle]')) setCover(t.checked);
  });

  // Fires (non-bubbling on the drawer, bubbling on the cart page) after the theme re-renders the cart.
  document.addEventListener('cart:rerendered', function () { scheduleSync(80); }, true);
  document.addEventListener('product:added', function () { scheduleSync(600); }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSync(200); });
  } else {
    scheduleSync(200);
  }

  window.RSCover = { sync: sync, set: setCover, tierFor: function (cents) { var c = cfg(); return c && tierFor(c, cents); } };
})();
